import React, { useState, useEffect } from "react";

interface CheckboxOption {
  label: string;
  value: string;
}

interface CheckboxProps {
  optionList: CheckboxOption[];
  disabled?: boolean;
  style?: React.CSSProperties;
  customLabelStyle?: React.CSSProperties;
  onChangeCb?: (selectedValues: string[]) => void;
  initialValues?: string[];
}

const EventEHRCheckbox = ({
  optionList,
  style,
  disabled = false,
  customLabelStyle = {},
  onChangeCb,
  initialValues = [],
}: CheckboxProps) => {
  const [selectedValues, setSelectedValues] = useState(() => {
    // Initialize with initialValues if provided
    if (initialValues.length > 0) {
      return optionList.map((option) => initialValues.includes(option.value));
    }
    return optionList.map(() => false);
  });

  // Update selectedValues when initialValues change
  useEffect(() => {
    console.log("EventEHRCheckbox - initialValues:", initialValues);
    if (initialValues.length > 0) {
      const newSelectedValues = optionList.map((option) =>
        initialValues.includes(option.value)
      );
      console.log("EventEHRCheckbox - newSelectedValues:", newSelectedValues);
      setSelectedValues(newSelectedValues);
    }
  }, [initialValues, optionList]);

  const handleChange = (index: number) => {
    const newSelectedValues = selectedValues.map((value: boolean, i: number) =>
      i === index ? !value : value
    );
    setSelectedValues(newSelectedValues);

    // Call the onChangeCb with selected option values
    if (onChangeCb) {
      const selectedOptionValues = optionList
        .filter((_: CheckboxOption, i: number) => newSelectedValues[i])
        .map((option: CheckboxOption) => option.value);
      onChangeCb(selectedOptionValues);
    }
  };

  return (
    <div className="space-x-5" style={style}>
      {optionList.map((option: CheckboxOption, index: number) => (
        <div
          key={option?.value}
          className=" space-x-2 items-center cursor-pointer flex "
        >
          <div className="w-[24px] ">
            <input
              type="checkbox"
              value={option.value}
              checked={selectedValues[index]}
              onChange={() => handleChange(index)}
              disabled={disabled}
              className="w-[20px] h-[20px] top-[2px] left-[2px] border rounded-md border-[#95929E] accent-[#005596] cursor-pointer"
            />
          </div>
          <div
            className={`font-medium text-[16px] leading-[19.2px]  text-[#565656] items-center justify-center text-start bottom-1 relative ${disabled ? "opacity-50 cursor-not-allowed" : ""}`}
            style={customLabelStyle}
          >
            {option.label}
          </div>
        </div>
      ))}
    </div>
  );
};

export default EventEHRCheckbox;
